import type { State } from 'state';

export const isChatSideBarOpen = (state: State): boolean => state.ui.chatDetails.isChatSideBarOpen;
